import { styled } from "styled-components";

export const LogosWrapper = styled.div`
  display: flex;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

export const LogosHeader = styled.p`
  color: ${(props) => props.theme.colors.default[900]};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  line-height: normal;
  z-index: 3;
`;

export const LogosCarousel = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 90px;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 0 24px;

  /* Hide the scrollbar */

  &::-webkit-scrollbar {
    display: none;
  }

  /* Gradient overlays */

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100px; /* Adjust the width of the gradient as needed */
    z-index: 2;
    pointer-events: none; /* Allows clicks to pass through */
  }

  &::before {
    left: 0;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.base},
      transparent
    );
  }

  &::after {
    right: 0;
    background: linear-gradient(
      to left,
      ${({ theme }) => theme.colors.base},
      transparent
    );
  }
`;

export const Logo = styled.div`
  padding: 14px 0px;
  flex-shrink: 0;
  opacity: 35%;
`;
